module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04bc701e6911ba0288abe6ad05b4a87d.png";